
import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import TextInput from "@/components/Reusable/CustomInputs/TextInput.vue";
import Dropdown from "@/components/Reusable/Dropdown/Dropdown.vue";
import { DatePickerOptions } from "@/types/controls";
import { isArray } from "lodash";
import isEqual from "lodash/isEqual";

@Component({
  components: { Dropdown, TextInput }
})
export default class DatePickerInput extends Vue {
  @Prop()
  value!: string | string[];

  @Prop()
  options?: DatePickerOptions;

  datePickerOpen = false;

  // changing from "range" to "multiple" can create nonsensical states in the the date picker
  @Watch("options")
  cleanValueIfOptionsChange(
    newOptions: DatePickerOptions,
    oldOptions: DatePickerOptions
  ) {
    if (!isEqual(newOptions, oldOptions)) {
      if (this.options?.range || this.options?.multiple) {
        this.$emit("input", []);
      } else {
        this.$emit("input", "");
      }
    }
  }

  get dateValue() {
    if (!isArray(this.value)) {
      return this.value;
    }

    if (this.options?.range) {
      const [from, to] = this.value;

      if (from && to) {
        return `from ${from} to ${to}`;
      }

      if (from) {
        return from;
      }
    }

    if (this.options?.multiple) {
      return this.value.join(", ");
    }

    return "";
  }
}
